module.exports = __webpack_public_path__ + "876805f1990cbdf8a45c92fa73f3d8fd.png";